import { Route, Routes } from "react-router-dom";

import VaBundledIntakeForm from "./IntakeForm";
import VaBundledProgramInfo from "./ProgramInfo";

const VaBundledSplashPage = () => {
  return (
    <Routes>
      <Route path="/" element={<VaBundledProgramInfo />} />

      <Route path="/intake-form/*" element={<VaBundledIntakeForm />} />
    </Routes>
  );
};

export default VaBundledSplashPage;
